<template>
  <div class="page">
    <el-row class="statusBar">
      <el-col :span="20">
        <el-menu :default-active="menus[0]" class="el-menu-demo" mode="horizontal"
                 @select="handleStatusSelect">
          <el-menu-item v-for="item in menus" :key="item" :index="item">
            {{ item }}
          </el-menu-item>
        </el-menu>
      </el-col>
      <el-col :span="4">
        <el-button type="primary" @click="addQualification">新增资质</el-button>
      </el-col>
    </el-row>
    <el-row class="topBar">
      <el-col :span="2">
        <label>资质类别</label>
      </el-col>
      <el-col :span="6">
        <el-select v-model="requestData.type" placeholder="请选择资质类别" size="mini">
          <el-option
              v-for="item in qualificationTypes"
              :key="item"
              :label="item"
              :value="item">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="2">
        <label>搜索</label>
      </el-col>
      <el-col :span="6">
        <el-input v-model="requestData.key" size="mini"
                  placeholder="请输入资质名称进行搜索" @change="getQualificationList">
          <el-button slot="append" icon="el-icon-search" @click="getQualificationList"></el-button>
        </el-input>
      </el-col>
    </el-row>
    <el-row class="qualificationTable">
      <el-col>
        <el-table :data="tableData" :header-cell-style="headerClass" :border="false">
          <el-table-column prop="name" label="资质名称" :border="false"></el-table-column>
          <el-table-column prop="type" label="资质类别"></el-table-column>
          <el-table-column prop="status" label="审核状态" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.status === '已驳回'" style="color: red">{{ scope.row.status }}</div>
              <div v-else>{{ scope.row.status }}</div>
              <el-tooltip class="item" effect="dark"
                          :content="scope.row.operationReason"
                          placement="top"
                          v-if="scope.row.status === '已驳回'"
              >
                <div v-if="scope.row.status === '已驳回'" class="rejectReason">{{ scope.row.operationReason }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="有效期" align="center">
            <el-table-column prop="startTime" align="right">
              <template slot-scope="scope">{{ scope.row.startTime | dateFormat }}</template>
            </el-table-column>
            <el-table-column width="30px" align="center">-</el-table-column>
            <el-table-column prop="endTime" align="left">
              <template slot-scope="scope">{{ scope.row.endTime | dateFormat }}</template>
            </el-table-column>
          </el-table-column>
          <el-table-column prop="file" label="文件" align="center">
            <template slot-scope="scope">
              <div v-for="item in scope.row.file" :key="item.name">
                <a :href="item.url" target="_blank" class="fileLink">{{ item.name }}</a>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <template v-if="requestData.status === '已审核'">
                <el-button type="text" @click="modifyQualification(scope.row)">编辑</el-button>
                <el-button type="text" @click="deleteQualification(scope.row.id)">注销</el-button>
              </template>
              <template v-else-if="requestData.status === '待审核'">
                <!--                待审核的不能注销-->
                <!--                <el-button type="text" @click="deleteQualification(scope.row.id)">撤回提交</el-button>-->
              </template>
              <template v-else-if="requestData.status === '已驳回'">
                <el-button type="text" @click="modifyQualification(scope.row)">编辑</el-button>
                <el-button type="text" @click="requestRecheckQualification(scope.row.id)">重新提交</el-button>
              </template>
              <template v-else-if="requestData.status === '已注销'">
                <!--                <el-button type="text"></el-button>-->
              </template>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!--    新增资质-->
    <el-dialog :title="qualificationDialog.mode"
               :visible.sync="qualificationDialog.dialogVisible"
               width="750px"
               :before-close="handleDialogClose"
               @close="initDialog">
      <el-form ref="form"
               :model="qualificationForm"
               :rules="rules"
               label-width="80px"
               style="margin-right: 10px; margin-left: 10px">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="name" label="资质名称">
              <el-input v-model="qualificationForm.name" placeholder="请输入资质名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="type" label="资质类别">
              <el-select v-model="qualificationForm.type" placeholder="请选择资质类别">
                <el-option
                    v-for="item in qualificationTypes"
                    :key="item"
                    :label="item"
                    :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item prop="dateRange" label="有效时间">
              <el-date-picker
                  v-model="qualificationForm.dateRange"
                  type="daterange"
                  value-format="timestamp"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item prop="file" label="上传文件">
              <el-upload
                  class="upload-demo"
                  style="text-align: left"
                  action=""
                  :on-preview="handlePreview"
                  :on-remove="handleRemove"
                  :before-remove="beforeRemove"
                  :http-request="httpRequestOfQualification"
                  :file-list="qualificationForm.file">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">只能上传pdf文件或图片</div>
                <!--                <div :style="{'visibility': fileValid.indexOf(index) !== -1 ? 'visible' : 'hidden', 'color': '#F56C6C'}"-->
                <!--                     slot="tip" class="el-upload__tip">未上传资质文件！-->
                <!--                </div>-->
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onSubmit('form')">{{ qualificationDialog.buttonInfo }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import GLOBAL from "@/utils/global.js";
export default {
  name: "QualificationManagement",
  filters: {
    dateFormat(val) {
      let date = new Date(val);
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      let d = date.getDate();
      return y + '/' + m + '/' + d;
    }
  },
  data() {
    return {
      GLOBAL,
      //资质类别
      qualificationTypes: [],
      menus: ['已审核', '待审核', '已驳回', '已注销'],
      requestData: {
        status: '已审核',
        type: '',
        key: ''
      },
      tableData: [],
      qualificationDialog: {
        mode: '新增资质',
        dialogVisible: false,
        buttonInfo: '提交'
      },
      qualificationForm: {
        name: '',
        type: '',
        dateRange: [],
        file: [],
      },
      rules: {
        name: {required: true, message: '请输入资质名称', trigger: 'blur'},
        type: {required: true, message: '请选择资质类别', trigger: 'change'},
        dateRange: {type: 'array', required: true, message: '请选择日期', trigger: 'change'},
        file: {type: 'array', required: true, message: '请选择文件', trigger: 'change'},
      }
    }
  },
  created() {
    this.getQualificationList();
    this.getQualificationTypes();
  },
  methods: {
    handleStatusSelect(key) {
      this.requestData.status = key;
      this.requestData.type = '';
      this.requestData.key = '';
      this.getQualificationList();
    },
    httpRequestOfQualification(param) {
      let fileObj = param.file; // 相当于input里取得的files
      let formData = new FormData(); // FormData 对象
      formData.append("file", fileObj); // 文件对象
      formData.append('type', '资质')
      // console.log(param.file);
      this.$store.dispatch("Qualification/uploadQualification", formData)
          .then((res) => {
            this.qualificationForm.file.push({
              name: fileObj.name,
              url: res.data.data
            })
          })
          .catch((res) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
          })
    },
    //删除文件
    handleRemove(file, fileList) {
      this.qualificationForm.file = fileList;
    },
    handlePreview(file) {
      // console.log(file);
      const el = document.createElement('a');
      el.style.display = 'none';
      el.setAttribute('target', '_blank');
      el.setAttribute('href', file.url);
      document.body.appendChild(el);
      el.click();
      document.body.removeChild(el);
    },
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    //表头样式
    //eslint-disable-next-line
    headerClass({row, column, rowIndex, columnIndex}) {
      if (rowIndex === 1) {
        return 'display: none'
      }
      return 'background: #EBEEF5; text-align: center'
    },
    //新增
    addQualification() {
      this.qualificationDialog.dialogVisible = true;
      this.qualificationDialog.mode = '新增资质';
    },
    //编辑
    modifyQualification(row) {
      this.qualificationDialog.dialogVisible = true;
      this.qualificationDialog.mode = '编辑资质';
      this.qualificationForm = {...row};
      //服了后端的时间格式，一会时间戳，一会其他格式
      this.$set(this.qualificationForm, 'dateRange', [new Date(row.startTime).getTime(), new Date(row.endTime).getTime()]);
      this.qualificationForm.file = row.file;
      if(!this.$store.state.visitorMode && GLOBAL.debugMode){
        console.log(this.qualificationForm);
      }
    },
    //时间回显
    changeDate(e) {
      this.$nextTick(() => {
        this.$set(this.qualificationForm, 'dateRange', [e[0], e[1]]);
      })
    },
    handleDialogClose(done) {
      this.$confirm("操作未保存，是否退出？")
          .then(() => {
            done();
          })
          .catch(() => {
          });
    },
    initDialog() {
      this.qualificationForm = {
        name: '',
        type: '',
        dateRange: [],
        file: [],
      };
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid && this.qualificationForm.dateRange !== [] && this.qualificationForm.file !== []) {
          if (this.qualificationDialog.mode === '新增资质') {
            this.$store.dispatch('Qualification/addQualification', this.qualificationForm)
                .then((res) => {
                  if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                    console.log(res);
                  }
                  this.getQualificationList();
                  this.qualificationDialog.dialogVisible = false;
                  this.$message({
                    type: 'success',
                    message: '新增资质成功!'
                  });
                })
                .catch((err) => {
                  if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                    console.log(err);
                  }
                  this.$confirm(`${err.response.data.message}，请重新输入`, {
                    confirmButtonText: '确定',
                    type: 'warning'
                  })
                      .then(() => {
                        this.$message({
                          type: 'info',
                          message: '继续编辑'
                        });
                      })
                })
          } else if (this.qualificationDialog.mode === '编辑资质') {
            this.$store.dispatch('Qualification/modifyQualification', this.qualificationForm)
                .then((res) => {
                  if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                    console.log(res);
                  }
                  this.getQualificationList();
                  this.qualificationDialog.dialogVisible = false;
                  this.$message({
                    type: 'success',
                    message: '编辑资质成功!'
                  });
                })
                .catch((err) => {
                  if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                    console.log(err);
                  }
                  this.$confirm(`${err.response.data.message}，请重新输入`, {
                    confirmButtonText: '确定',
                    type: 'warning'
                  })
                      .then(() => {
                        this.$message({
                          type: 'info',
                          message: '继续编辑'
                        });
                      })
                })
          }
        }
      })
    },
    getQualificationList() {
      this.$store.dispatch("Qualification/getQualificationList", this.requestData)
          .then((res) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
            this.tableData = res.data.data;
          })
          .catch((err) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(err);
            }
          })
    },
    //获取资质类别列表
    getQualificationTypes() {
      this.$store.dispatch('Qualification/getQualificationTypes')
          .then((res) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(res);
            }
            this.qualificationTypes = res.data.data;
          })
          .catch((err) => {
            if(!this.$store.state.visitorMode && GLOBAL.debugMode){
              console.log(err);
            }
          })
    },
    //  注销资质
    deleteQualification(val) {
      this.$confirm('确认删除该资质吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('Qualification/deleteQualification', {
          qualificationId: val,
        })
            .then((res) => {
              if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                console.log(res);
              }
              this.getQualificationList();
            })
            .catch((err) => {
              if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                console.log(err);
              }
            })
      })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          })
    },
    //被驳回的，重新提交
    requestRecheckQualification(val) {
      this.$confirm('确认重新提交吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('Qualification/requestRecheckQualification', {
          qualificationId: val,
        })
            .then((res) => {
              if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                console.log(res);
              }
              this.getQualificationList();
            })
            .catch((err) => {
              if(!this.$store.state.visitorMode && GLOBAL.debugMode){
                console.log(err);
              }
            })
      })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消重新提交'
            });
          })
    }
  },
  watch: {
    requestData: {
      deep: true,
      handler: function () {
        this.getQualificationList();
      }
    }
  }
}
</script>

<style scoped>
.page {
  /*padding: 10px;*/
}

.statusBar {
  border-bottom: 1px solid #e6e6e6;
}

.statusBar .el-button {
  margin-top: 10px;
}

.el-menu.el-menu--horizontal {
  border-bottom: none;
}

.topBar {
  display: flex;
  align-items: baseline;
  padding: 10px;
}

.qualificationTable {
  padding: 10px;
}

.fileLink {
  color: #409eff;
  text-decoration: none;
}

.fileLink:hover {
  color: rgb(102, 177, 255);
}

/deep/ .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left ~ .el-table__fixed {
  border-right: none;
}

.rejectReason {
  color: #8c939d;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  word-break: break-all;
  -webkit-line-clamp: 1; /*可以显示的行数，超出部分用...表示 */
  -webkit-box-orient: vertical;
}
</style>
